/*Mahesh S  : 05-10-2023 : BT-105135 -  Breeze- Portfolio Holdings - Start*/
import { memo, useEffect, useMemo, useState } from 'react';
import Popover from 'react-bootstrap/Popover';
import { BzPopoverOverlay, BzChip, BzToolTip } from "../../components";
import { Col, Row } from 'react-bootstrap';
import { useSelector, useDispatch } from 'react-redux';
import { SCRIP_INSTRUMENTS, WATCHLIST_GRID_INDEX, FACILITY_NUM, ORDER_PRODUCT_TYPES } from '../../utils/global_variables';
import { getDontMissInfo } from '../../redux/actions/dontMiss';
import { useLeftClick } from '../../hooks';
import { HOILDING_GRID_REF, ORDER_ENTRY_GRID_REF, convertDateToSeconds, convertScripResponseWatchlistGrid, getApiExchangeNameFromMktSegId, getChangeInRs, getDecimalLocatorFromApiExchangeName, getDynamicParamsForToFixed, removeExpiriedScrip } from '../../utils/global_functions';
import { useLocation } from 'react-router';
import { getExchangeWiseScripInfo, getScripOrderInfo } from '../../redux/actions/orders';
import { handleModal, handleModalData } from '../../redux/actions/modals';
import { sendBestFiveRequest } from '../../apis/web_socket';
import { setScripOverviewData } from '../../redux/actions/marketOverview';
//Prachi T :BT-107377 - 17-11-2023 ScripInnfo recommendations - Start
import { toastConfig } from '../../redux/actions/toast';
import { _getProductType } from '../../controllers';
import { setIsIndicesOverview } from '../../redux/actions/indices';
import { setArrScripToBeAdded } from '../../redux/actions/globalSearch';
//Prachi T :BT-107377 - 17-11-2023 ScripInnfo recommendations - End

const HoldingsPopover = ({ className, children, setIsChartWidget, toggleTabs, bScroll, setbScroll, ...props }) => {
    const { data } = props;
    const dispatch = useDispatch();
    const [arrRowData, setArrRowData] = useState([]);
    const [holdingInfo, setHoldingInfo] = useState([]);
    const holdingsScrips = useSelector(state => state.holdings.holdingsScrips);
    const objCFT = useSelector(state => state?.auth?.objCFT);//ManasaB : 23/11/2023 : BT-115296 Calculator Bug Fixing 
    useEffect(() => {
        dispatch(getDontMissInfo());
    }, [dispatch]);
    const { dontMissData } = useSelector(state => state.dontMiss);
    //Prachi T :BT-107377 - 17-11-2023 ScripInnfo recommendations - Start
    const objLoginSession = useSelector(state => state.auth.objLoginSession);
    //Prachi T :BT-107377 - 17-11-2023 ScripInnfo recommendations - End
    const [showPopover, setShowPopover] = useState(false);
    //ManasaB : 13-06-2024 : Changed to left click in grid : Start
    const leftClick = (e) => {
        if (e?.button === 0) {
            setShowPopover(false);
        }
    };
    const [rightClickTargetElement] = useLeftClick(leftClick);
    //ManasaB : 13-06-2024 : Changed to left click in grid : End
    const [placement, setPlacement] = useState();
    const onContextMenu = (e) => {
        if (e?.ctrlKey) {
            return;
        }
        if (props?.node?.rowHeight) {
            const rowHeight = props?.node?.rowHeight;
            const mousePointer = e?.clientY;
            const screenHeight = window?.innerHeight;
            const multiplier = 4;
            const position = mousePointer + rowHeight * multiplier > screenHeight ? 'top' : 'bottom';
            setPlacement(position);
        }
        // e.preventDefault();
        // if (setIsGlobalSearch) {
        //     setIsGlobalSearch(false);
        // } else { }
        setShowPopover(true);
    };
    useEffect(() => {
        const handleKeyDown = (event) => {
            if (['F1', 'F2', 'F3', 'F5', 'F6', 'n', 'v', 'V', 'Enter'].includes(event.key)) {
                setShowPopover(false);
            }
        };
        document.addEventListener('keydown', handleKeyDown);
        return () => {

            document.removeEventListener('keydown', handleKeyDown);
        };
    }, []);
    useEffect(() => {
        setArrRowData(convertScripResponseWatchlistGrid(data?.ScripData)?.[0]);
    }, [data]);
    useEffect(() => {
        if (bScroll) {
            setShowPopover(false);
        } else { }
    }, [bScroll]);
    let location = useLocation();
    useEffect(() => {
        if (location?.state?.length > 0) {
            const nIndex = HOILDING_GRID_REF?.current?.api?.getRowNode(location?.state)?.rowIndex;
            HOILDING_GRID_REF?.current?.api?.getDisplayedRowAtIndex(nIndex)?.setSelected(true, true);
            HOILDING_GRID_REF?.current?.api?.getDisplayedRowAtIndex(nIndex).setExpanded(true);
            setShowPopover(false);
        } else { }
    }, [location.state]);

    // const handleDropDown = () => {
    //     const nIndex = HOILDING_GRID_REF?.current?.api?.getRowNode(data?.segmentIdToken).rowIndex;
    //     HOILDING_GRID_REF?.current?.api?.getDisplayedRowAtIndex(nIndex).setExpanded(true);
    //     setShowPopover(false);
    // };

    const productTypeData = useSelector(state => state?.orders?.productTypes);// Azeem K:29-02-2024:BT_102298:BSEEQ default deliver prod type 
    const handleBuySell = (holdingsDetails, type, event) => {
        if (arrRowData?.length) {
            const strProductTypeDesc = _getProductType(ORDER_PRODUCT_TYPES.DELIVERY, getApiExchangeNameFromMktSegId(holdingsDetails?.nMarketSegmentId), productTypeData, objLoginSession);// Azeem K:29-02-2024:BT_102298:BSEEQ default deliver prod type 
            const strExchangeName = getApiExchangeNameFromMktSegId(holdingsDetails?.nMarketSegmentId);
            if (objLoginSession?.data?.exchanges?.includes(strExchangeName?.toUpperCase())) {
                setShowPopover(false);
                dispatch(getExchangeWiseScripInfo(holdingsDetails));
                ORDER_ENTRY_GRID_REF?.current?.setOrderInputs(curr => ({ ...curr, scripPrice: holdingsDetails.ltp, scripLot: type === 'SELL' ? holdingsDetails?.qty : 1 }));
                ORDER_ENTRY_GRID_REF?.current?.setSelectOrderOption(prev => ({ ...prev, productType: ORDER_PRODUCT_TYPES.DELIVERY, productTypeDesc: strProductTypeDesc, isDefaultProductType: false, }));// Azeem K:29-02-2024:BT_102298:BSEEQ default deliver prod type 
                dispatch(handleModalData({ rowDetails: holdingsDetails }));
                const arrHoldingsDetails = convertScripResponseWatchlistGrid(holdingsDetails?.ScripData);
                if (arrHoldingsDetails[0]?.length > 0) {
                    dispatch(getScripOrderInfo({ activeExchangeId: arrHoldingsDetails[WATCHLIST_GRID_INDEX?.SEGMENT_ID], isBuySell: type === 'BUY' ? 0 : 1, scripData: arrHoldingsDetails[0], bIsHoldingsSell: type === 'SELL' ? true : false }));//  Azeem K : 27-02-2024 : BT-102298 - Breeze - Single Scrip Order entry - BSEEQ   bIsHoldingsSell added
                }
                dispatch(handleModal([{ "ORDER_ENTRY_MODAL": true }]));
            } else {
                dispatch(toastConfig({ autoDismiss: true, show: true, message: `You are currently not allowed to place/modify/cancel order in this segment` }));
            }
        } else {
            dispatch(toastConfig({ show: true, autoDismiss: true, timer: 2000, message: 'Unable to gt Scrip Details' }));
        }
    };
    //Prachi T :BT-107377 - 17-11-2023 ScripInnfo recommendations - End

    const [dontMissChips, setDontMissChips] = useState();

    useEffect(() => {
        const objDontMiss = dontMissData.find(element => element[WATCHLIST_GRID_INDEX.SEGMENT_ID_TOKEN] === data?.segmentIdToken);
        if (objDontMiss !== undefined) {
            setDontMissChips(objDontMiss[WATCHLIST_GRID_INDEX.DONT_MISS]);
        }
    }, [dontMissData]);
    //Vaibhav Singh : 09-11-23: BT-109089: Added handle for Portfolio Scrip Overview : Start
    const handleOverview = async () => {
        if (arrRowData?.length) {
            setShowPopover(false);
            const scripData = convertScripResponseWatchlistGrid(data?.ScripData);
            sendBestFiveRequest({ exchangeId: scripData?.[0]?.[WATCHLIST_GRID_INDEX.SEGMENT_ID], token: scripData?.[0]?.[WATCHLIST_GRID_INDEX.TOKEN], isSubscribe: true });
            dispatch(setScripOverviewData(scripData?.[0]));
            dispatch(handleModal([{ 'MARKET_OVERVIEW_MODAL': true }]));
        } else {
            dispatch(toastConfig({ show: true, autoDismiss: true, timer: 2000, message: 'Unable to gt Scrip Details' }));
        };
    };

    const handleChart = () => {
        if (arrRowData?.length) {
            setShowPopover(false);
            const isNotExpired = removeExpiriedScrip(convertDateToSeconds(arrRowData[WATCHLIST_GRID_INDEX.EXPIRYDATE]));
            if (isNotExpired) {
                dispatch(handleModal([{ 'MARKET_OVERVIEW_MODAL': true }], true));
                dispatch(setScripOverviewData(arrRowData));
                dispatch(handleModalData({ tab: 'analysis' }));
                dispatch(setIsIndicesOverview(false));
            } else {
                dispatch(toastConfig({ show: true, autoDismiss: true, timer: 3000, message: 'Selected scrip has expired!', }));
            }
        } else {
            dispatch(toastConfig({ show: true, autoDismiss: true, timer: 2000, message: 'Unable to gt Scrip Details' }));
        }
    };
    const handleAddToWatchlist = () => {
        if (arrRowData?.length) {
            setShowPopover(false);
            dispatch(setArrScripToBeAdded([arrRowData]));
            dispatch(handleModal([{ 'GLOBAL_SEARCH_ADDSCRIP_MODAL': true }]));
        } else {
            dispatch(toastConfig({ show: true, autoDismiss: true, timer: 2000, message: 'Unable to gt Scrip Details' }));
        }
    };
    //Vaibhav Singh : 09-11-23: BT-109089: Added handle for Portfolio Scrip Overview : End
    //Azeem Khan : 23-04-2024 : BT-107432 -  Breeze - Alerts - Start
    const handleSetAlert = (data) => {
        setShowPopover(false);
        let strExchangeSegment = getApiExchangeNameFromMktSegId(data?.nMarketSegmentId);
        dispatch(handleModalData({
            AlertData: {
                symbol: data?.sSymbol,
                exchange: strExchangeSegment?.split('_')[0],
                series: data?.sSeries,
                description: data?.sSeries,
                token: data?.nToken,
                mktId: data?.nMarketSegmentId,
                decimalLocator: getDecimalLocatorFromApiExchangeName(strExchangeSegment),
                decimalLocator_length: getDynamicParamsForToFixed(strExchangeSegment),
                exchange_segement: strExchangeSegment
            },
            isShowAlerts: true
        }));

        dispatch(handleModal([{ "SET_ALERT_MODAL": true }]));
    };
    //Azeem Khan : 23-04-2024 : BT-107432 -  Breeze - Alerts - End
    const getHoldingsData = useMemo(() => {
        if (holdingsScrips?.length && arrRowData?.length) {
            //Vaibhav Singh:16-12-23: BT-107055: ISIN code added fixed totalfreequantity also updated: Start
            let nIndex = holdingsScrips?.findIndex((eachHolding) => eachHolding?.TOTALFREEQUANTITY !== "0" && eachHolding?.ISIN === arrRowData[WATCHLIST_GRID_INDEX.ISIN_CODE] && arrRowData[WATCHLIST_GRID_INDEX.INSTRUMENT] === SCRIP_INSTRUMENTS.EQUITIES);
            //Vaibhav Singh:16-12-23: BT-107055: ISIN code added fixed totalfreequantity also updated: End
            return nIndex;
        } else { return -1; }
    }, [holdingsScrips, arrRowData]);
    // Ameersha N | BT-95888 Create Watchlist Feature end
    //Vaibhav Singh: 01-12-23:BT-109089: Added holding Logic in popover : Start
    useEffect(() => {
        if (holdingsScrips?.length && arrRowData?.length) {
            if (holdingsScrips[getHoldingsData]?.nBuyAvgPrice && parseFloat(arrRowData[WATCHLIST_GRID_INDEX.LAST_TRADE_PRICE]) !== 0) {
                let arrNetChangePNL = getChangeInRs((arrRowData[WATCHLIST_GRID_INDEX.LAST_TRADE_PRICE] * holdingsScrips[getHoldingsData]['TOTALFREEQUANTITY']).toFixed(2), (parseFloat(holdingsScrips[getHoldingsData]?.nBuyAvgPrice) * parseInt(holdingsScrips[getHoldingsData]?.TOTALFREEQUANTITY)).toFixed(2), 2, false, 'uptrend');
                setHoldingInfo(arrNetChangePNL);
            }
        } else {
            setHoldingInfo([]);
        }
    }, [arrRowData]);
    const BzPopover = (
        <Popover className='scripdetails-popover'>

            <Popover.Header>
                <div className='p-2'>
                    <Row className='g-0'>
                        <Col className='justify-content-start align-items-start'>
                            <Row className='g-0 align-items-start'>
                                <Col md={7} className='d-flex flex-row align-items-center'>
                                    <div className='font-medium font-size4 color-text float-start me-2'>{data?.sSymbol}</div>
                                </Col>
                                <Col md={5} className='d-flex justify-content-end'>
                                    {
                                        arrRowData?.length > 0
                                            ?
                                            <div className='font-medium font-size4 color-text'>{data?.ltp}</div>
                                            :
                                            <div className='font-medium font-size4 color-text'>{(0).toFixed(2)}</div>
                                    }
                                </Col>
                            </Row>
                            <Row className='g-0 justify-content-end'>
                                <Col md={5} className='d-flex justify-content-end'>
                                    {
                                        arrRowData?.length > 0
                                            ?
                                            <>
                                                <div className={`font-medium font-size2 color-text float-start ${parseFloat(arrRowData[WATCHLIST_GRID_INDEX.ABSOLUTE_NET_CHANGE_FROM_PRE_CLOSE]) < 0 ? 'color-negative' : parseFloat(arrRowData[WATCHLIST_GRID_INDEX.ABSOLUTE_NET_CHANGE_FROM_PRE_CLOSE]) === 0 ? 'color-text' : 'color-positive'}`}>
                                                    {parseFloat(arrRowData[WATCHLIST_GRID_INDEX.ABSOLUTE_NET_CHANGE_FROM_PRE_CLOSE])?.toFixed(2)}</div>
                                                <div className={`font-medium font-size2 color-text ms-1 ${parseFloat(arrRowData?.[WATCHLIST_GRID_INDEX.NET_CHANGE_FROM_PRE_CLOSE]) < 0 ? 'color-negative' : parseFloat(arrRowData?.[WATCHLIST_GRID_INDEX.NET_CHANGE_FROM_PRE_CLOSE]) === 0 ? 'color-text' : 'color-positive'}`}>({parseFloat(arrRowData?.[WATCHLIST_GRID_INDEX?.NET_CHANGE_FROM_PRE_CLOSE])?.toFixed(2)}%)</div>
                                            </>
                                            :
                                            <div className={`font-medium font-size2 color-text`}>{(0).toFixed(2)} {(0).toFixed(2)}%</div>
                                    }
                                </Col>
                            </Row>
                        </Col>
                    </Row>
                </div>
            </Popover.Header>

            <Popover.Body className='d-flex flex-column'>
                <div className='bdr-top'>
                    <Row className='g-0 p-2'>
                        <Col className='d-flex justify-content-around'>
                            <BzToolTip placement={'bottom'} TooltipMsg={'Overview'}>
                                <button className='btn btn-sm btn-outline d-flex align-items-center justify-content-center me-2' onClick={handleOverview}>
                                    <div class="icon-20 icon-eye icon-primary"></div>
                                </button>
                            </BzToolTip>

                            <BzToolTip placement={'bottom'} TooltipMsg={'Chart'}>
                                <button className='btn btn-sm btn-outline d-flex align-items-center justify-content-center me-2' onClick={handleChart}>
                                    <div class="icon-20 icon-graph icon-primary"></div>
                                </button>
                            </BzToolTip>
                            {
                                objCFT.ALERT === FACILITY_NUM.ON && (
                                    <BzToolTip placement={'bottom'} TooltipMsg={'Alert'}>
                                        <button className='btn btn-sm btn-outline d-flex align-items-center justify-content-center me-2' onClick={handleSetAlert?.bind(this, data)}>
                                            <div class="icon-20 icon-alert icon-primary"></div>
                                        </button>
                                    </BzToolTip>
                                )
                            }
                            {true &&
                                <BzToolTip placement={'bottom'} TooltipMsg={'Add to watchlist'}>
                                    <button className='btn btn-sm btn-outline d-flex align-items-center justify-content-center me-2' onClick={handleAddToWatchlist}>
                                        <div class="icon-20 icon-add-circle icon-primary"></div>
                                    </button>
                                </BzToolTip>
                            }
                            <button onClick={() => handleBuySell(data, 'BUY')} className='btn btn-sm btn-positive text-uppercase me-2'>&nbsp;B&nbsp;</button>
                            <button onClick={() => handleBuySell(data, 'SELL')} className='btn btn-sm btn-negative text-uppercase'>&nbsp;S&nbsp;</button>
                        </Col>
                    </Row>
                </div>
                <div className='px-2 pb-2'>
                    {getHoldingsData >= 0 &&
                        <Row className='g-0 py-2 cursor-pointer align-items-center'>
                            <Col className='d-flex'>
                                <div className='icon-16 icon-portfolio icon-dark'></div>
                                <div className='font-regular font-size2 color-text ms-2'>{holdingsScrips[getHoldingsData].TOTALFREEQUANTITY}</div>
                                {(holdingInfo?.length) ?
                                    <div className='d-flex align-items-center ms-2'>
                                        <div className={`font-regular font-size2 color-text ${holdingInfo[2]}`}>&#8377;{`${Number(holdingInfo[0]).toLocaleString('en-IN', { minimumFractionDigits: 2 })}`}</div>
                                        <div className={`font-regular font-size2 color-text ms-1 ${holdingInfo[2]}`}>({holdingInfo[1]})</div>
                                    </div>
                                    : null
                                }
                            </Col>
                        </Row>
                    }
                    {
                        dontMissData.some(element => element[WATCHLIST_GRID_INDEX.SEGMENT_ID_TOKEN] === data?.segmentIdToken)
                            ?
                            <Row className='g-0 py-2'>
                                <Col className='d-flex align-items-center'>
                                    <div className='icon-16 icon-dontmiss icon-yellow'></div>
                                    <div className='chips-wrap ms-2'>
                                        {
                                            dontMissChips?.map((objDontMiss, i) => (
                                                <BzChip key={i} className={`chips ${objDontMiss.color?.includes('negative') ? 'negative-chip' : (objDontMiss.color?.includes('positive') ? 'positive-chip' : '')} me-2`}>{objDontMiss?.event}</BzChip>
                                            ))
                                        }
                                    </div>
                                </Col>
                            </Row>
                            : null
                    }
                </div>
            </Popover.Body>
        </Popover >
    );

    return (
        <div >
            <BzPopoverOverlay rootClose trigger='click' show={showPopover} onToggle={() => setShowPopover(false)} placement={placement} popover={BzPopover}>
                <div ref={rightClickTargetElement} onClick={onContextMenu}>
                    {children}
                </div>
            </BzPopoverOverlay>
        </div>
    );
};

export default memo(HoldingsPopover);

/*Mahesh S  : 05-10-2023 : BT-105135 -  Breeze- Portfolio Holdings - end*/